export default __webpack_public_path__ + "static/media/ic-lead-site.9e393fcc.svg";